import * as ms from 'milliseconds';

export const GRID_UNIT = 8;

// The screen width at which the rail is automatically collapsed
export const RAIL_LARGE_SCREEN_THRESHOLD = 1126;

// Business logic and app constants (same across all environments)
export const NUM_CHAT_MESSAGES_TO_FETCH = 25;
export const CARD_PAGINATION_SIZE = 30;
export const PRICING_LIMIT_HISTORY_DAYS = 7;
export const RECURRENCE_CARD_COUNT = 60;

export const FONT_STACK =
  '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const HEADER_HEIGHT = 64;
export const PAGE_MODAL_WIDTH = 600;
export const EXTERNAL_FORM_MAX_WIDTH = 500;
export const CREATE_MODAL_FIXED_WIDTH = 800;
export const UPDATE_MODAL_FIXED_WIDTH = 1000;

// Gesture and animation thresholds
export const GESTURE_EXIT_VELOCITY = 0.2;
export const TOAST_DELAY_DURATION = ms.seconds(0.5);
export const TOAST_DEFAULT_DURATION = ms.seconds(10);
export const IS_TYPING_TIMEOUT_DURATION = ms.seconds(5);
export const IS_TYPING_UPDATE_THROTTLE_DURATION = ms.seconds(2);
export const MESSAGE_GROUPING_TIME_SPAN = ms.minutes(1);
export const WAIT_DURATION_BEFORE_PROMPTING_TO_NOTIFY_PENDING_USERS = ms.hours(24);
export const SEARCH_RESULT_NUM_CHARS_BEFORE_MATCH_TO_SHOW = 40;
export const DEFAULT_WEB_DATE_PICKER_TIME_INTERVAL_MINUTES = 15;
export const DISABLE_ANIMATIONS = false;
export const WARN_LOOPING_ANIMATIONS = false;
